import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryWebsiteGoods(
  {
    status,
    seriesId,
    categoryId,
    name,
    page,
    size,
    direction,
    sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods`,
    method: 'get',
    params: {
      status,
      seriesId,
      categoryId,
      name,
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryGoodsById(goodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods/${goodsId}`,
    method: 'get',
  });
}

/**
 * 新增
 */
export function _addGoods(
  {
    name,
    nameEn,
    code,
    seriesId,
    categoryId,
    gatherId,
    coverPath,
    images,
    limitedQuantity,
    status,
    sellStartAt,
    sellEndAt,
    price,
    description,
    descriptionEn,
    type,
    inspirationImg,
    inspirationVideo,
    isLimited,
    isVip,
    sizeImage,
    vipCategoryId,
    vipSeriesId,
    isNew,
    startPrice,
    endPrice,
    goldContent,
    menUse,
    dollarPrice,
    channel,
    material,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods`,
    method: 'post',
    data: {
      name,
      nameEn,
      code,
      seriesId,
      categoryId,
      gatherId,
      coverPath,
      images,
      limitedQuantity,
      status,
      sellStartAt,
      sellEndAt,
      price,
      description,
      descriptionEn,
      type,
      inspirationImg,
      inspirationVideo,
      isLimited,
      isVip,
      sizeImage,
      vipCategoryId,
      vipSeriesId,
      isNew,
      startPrice,
      endPrice,
      goldContent,
      menUse,
      dollarPrice,
      channel,
      material,
    },
  });
}

/**
 * 更新
 */
export function _updateGoods(goodsId, {
  name,
  nameEn,
  code,
  seriesId,
  categoryId,
  gatherId,
  coverPath,
  images,
  limitedQuantity,
  status,
  sellStartAt,
  sellEndAt,
  price,
  description,
  descriptionEn,
  type,
  inspirationImg,
  inspirationVideo,
  isLimited,
  isVip,
  sizeImage,
  vipCategoryId,
  vipSeriesId,
  isNew,
  startPrice,
  endPrice,
  goldContent,
  menUse,
  dollarPrice,
  channel,
  material,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods/${goodsId}`,
    method: 'patch',
    data: {
      name,
      nameEn,
      code,
      seriesId,
      categoryId,
      gatherId,
      coverPath,
      images,
      limitedQuantity,
      status,
      sellStartAt,
      sellEndAt,
      price,
      description,
      descriptionEn,
      type,
      inspirationImg,
      inspirationVideo,
      isLimited,
      isVip,
      sizeImage,
      vipCategoryId,
      vipSeriesId,
      isNew,
      startPrice,
      endPrice,
      goldContent,
      menUse,
      dollarPrice,
      channel,
      material,
    },
  });
}

/**
 * 删除
 * @param goodsId
 * @param code
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _setGoodsBasicSpec(goodsId, { code }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods/${goodsId}/basic-spec`,
    method: 'patch',
    data: {
      basicSpec: code,
    },
  });
}

/**
 * 删除
 * @param goodsId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteGoods(goodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods/${goodsId}`,
    method: 'delete',
  });
}

/**
 * 根据分类id 查询商品；
 * @param  categoryId
 * @returns
 */
export function _queryGoodsByCategoryId(categoryId, {
  page,
  size,
  sort,
  direction
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods/category/${categoryId}`,
    method: 'get',
    params: {
      page,
      size,
      sort,
      direction
    }
  });
}

/**
 * 批量更新
 * @param status
 * @param goodsIds
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _multiUpdateGoods(goodsIds, status) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods/multi/${status}`,
    method: 'patch',
    data: goodsIds,
  });
}

/**
 * 下架
 * @param goodsId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _offGoods(goodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods/${goodsId}/off`,
    method: 'patch',
  });
}

/**
 * 成本更新
 * @param goodsId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _goldPriceUpdate({ percentage }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods/gold-price`,
    method: 'post',
    data: {
      percentage
    }
  });
}

/**
 * 下架
 * @param goodsId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _goodsOnSell(goodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods/${goodsId}/sell`,
    method: 'patch',
  });
}

export function _importGoods(
  {
    goods,
    goodsAttributeValue,
    goodsSKU,
    goodsSkuAttributeValue,
  }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods/import`,
    method: 'post',
    data: {
      goods,
      goodsAttributeValue,
      goodsSKU,
      goodsSkuAttributeValue,
    }
  });
}

export function _updateGoodsSort({
  idStr, sortStr, oldIndex, newIndex
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website/goods/update`,
    method: 'post',
    params: {
      idStr: idStr,
      sortStr: sortStr,
      oldIndex: oldIndex,
      newIndex: newIndex
    }
  });
}

export function _queryCustomizeGoods() {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods/customize`,
    method: 'get',
  });
}
